import { render, staticRenderFns } from "./BuyDialog.vue?vue&type=template&id=040475e6"
import script from "./BuyDialog.vue?vue&type=script&lang=js"
export * from "./BuyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports